import { useState } from "react";
import * as Popover from "@radix-ui/react-popover";

import { HaNContext } from "@lib/logic";
import { getAllBuildings, getBuildingById, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";
import { Icon } from "@atoms";
import { cn } from "@utils";

import { BuildingList } from "./components/BuildingList";

/**
 * The building's name, as the page title. With more than one building, it opens a list of them to search and choose
 * from.
 */
export const BuildingSelector = () => {
  const { building } = useRequiredContext(HaNContext);
  const hasOtherBuildings = useAppSelector(state => getAllBuildings(state).length > 1);
  const buildingName = useAppSelector(state => getBuildingById(state, building.buildingId ?? ""))?.name;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover.Root
      open={isOpen}
      onOpenChange={setIsOpen}>
      <h1 className="min-w-0 truncate text-[17px] font-semibold leading-6 max-sm:font-display max-sm:text-[26px] max-sm:font-medium max-sm:leading-8">
        {hasOtherBuildings ? (
          <Popover.Trigger className="flex max-w-full items-center gap-2 rounded-md text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mapiq-black-800*">
            <span className="truncate">{buildingName}</span>
            <Icon
              aria-hidden
              icon="caretDown"
              color="currentColor"
              className={cn("size-4 flex-none transition-transform", { "rotate-180": isOpen })}
            />
          </Popover.Trigger>
        ) : (
          buildingName
        )}
      </h1>

      <Popover.Portal>
        <Popover.Content
          align="start"
          sideOffset={8}
          collisionPadding={16}
          className="z-50 flex max-h-[min(480px,var(--radix-popover-content-available-height,480px))] w-[320px] max-w-[calc(100vw-32px)] flex-col overflow-hidden rounded-lg bg-white shadow-mapiq-overlay">
          <BuildingList onChoose={() => setIsOpen(false)} />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
